import { useQuery } from '@tanstack/react-query';
import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { siteSettingsQuery } from '../api.ts';
import { ErrorNotice, Loading } from '../common.tsx';
import { Route as parent } from './site.tsx';
const Screen = lazy(async () => ({ default: (await import('../components/page-list.tsx')).PagesList }));
export const Route = createRoute({
  getParentRoute: () => parent,
  path: 'posts',
  component: RouteComponent,
});
function RouteComponent() {
  const { siteId } = Route.useParams();
  const { locale: requestedLocale } = Route.useSearch();
  const site = useQuery(siteSettingsQuery(siteId));
  if (site.isPending) return <Loading />;
  if (site.error) return <ErrorNotice error={site.error} />;
  const snapshot = { siteId, objects: [site.data!] };
  const locale = requestedLocale ?? site.data!.baseLocale;
  return (
    <Suspense fallback={<Loading />}>
      <Screen snapshot={snapshot} locale={locale} kind="Post" />
    </Suspense>
  );
}
